import React from 'react';

export const DocumentIcon = ({ color = '#2555FE', ...restProps }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M21 3H9C8.20435 3 7.44129 3.31607 6.87868 3.87868C6.31607 4.44129 6 5.20435 6 6V30C6 30.7956 6.31607 31.5587 6.87868 32.1213C7.44129 32.6839 8.20435 33 9 33H27C27.7956 33 28.5587 32.6839 29.1213 32.1213C29.6839 31.5587 30 30.7956 30 30V12L21 3Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21 3V12H30" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24 19.5H12" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24 25.5H12" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 13.5H13.5H12" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
